/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FunctionDataFromJSON, FunctionDataToJSON } from './';
export function FunctionsDataFromJSON(json) {
    return FunctionsDataFromJSONTyped(json, false);
}
export function FunctionsDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        en: json['en'].map(FunctionDataFromJSON),
    };
}
export function FunctionsDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        en: value.en.map(FunctionDataToJSON),
    };
}
